module.exports = __webpack_public_path__ + "img/circle-three-dots.6fe4677f.svg";